<template>
  <b-field :horizontal="horizontal" label="Group">
    <b-select v-model="value" @input="onInput" expanded :multiple="multiple" :disabled="loading" :loading="loading">
      <option value="" v-if="!multiple">
        <slot name="defaultOptionLabel">Please Select</slot>
      </option>
      <option v-for="option in options" :value="option.id" :key="option.id">
        {{ option.name }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { GroupService } from "@/services/group.service.js";

export default {
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: "",
    options: [],
    loading: false
  }),
  created() {
    this.fetchOptions();
    this.reset();
  },
  methods: {
    fetchOptions() {
      this.loading = true;

      GroupService.all().then(
        response => {
          this.options = JsonDenormalizer.denormalize(response);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      );
    },
    onInput() {
      this.$emit("input", this.value);
    },
    reset() {
      this.value = this.multiple ? [] : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/selectGroup.vue